import useAPI from '../hooks/useAPI.js';
import React, { useCallback } from 'react';
import ErrorBoundary from '../modules/errors/Boundary.js';
import { DrawingZone } from 'components/DrawingZone';
import { RemoteControl } from 'components/remote-control.js';
import Fullscreen from './Fullscreen.js';
import ExclusiveContent from './ExclusiveContent/index.js';
import { ImperativeRemoteControl } from './imperative-remote-control.js';
import { useSelector } from 'react-redux';

const sharedComponents = {
  DrawingZone,
  RemoteControl,
  ImperativeRemoteControl,
  Fullscreen,
  ExclusiveContent,
};
/**
 * @param {React.ReactPropTypes} props
 * @param {[Object]} props.extensions
 * @return {[React.ReactElement]}
 * @todo Найти решение лучше чем прокидывать внутрь каждого расширения  DrawingZone (и/или все остальные компоненты которые могут быть там нужны).
 *    Варианты:
 *    - определять обёртки, контексты и т.д. на основе описания расширения и применять здесь
 *    - определять и передавать в расширение
 *    - применить _как-то_ инверсию и предоставить в распоряжение каждого расширения все базовые возможности/компоненты интерактива
 *    - еще что-то
 */
export function Extensions(props){
  const API = useAPI();
  const extensions = useSelector((state) => {
    return state.extensions;
  });

  const onError = useCallback((error) => {
    console.error(error);
  }, []);

  return extensions.map((extension) => {
    /* User disable extension via settings */
    if(!extension.allowed) {
      return null;
    }

    /* ... or not ready yet*/
    if (!extension.consumable){
      return null;
    }

    /* ... or disabled for current video by admins */
    if(!extension.enabled){
      return null;
    }

    const impl = API.getExtension(extension);
    if (!impl) {
      return null;
    }

    return (
      <ErrorBoundary key={extension.name} onError={onError}>
        <impl.UI
          UI={sharedComponents}
          currentObject={props.currentObject}
          options={extension.options}
          enabled={extension.enabled}
        />
      </ErrorBoundary>
    )
  })
}
